<template>
  <div v-if="tempUserData" class="cbg-account">
    <p class="cbg-account__title">Account settings</p>
    <form class="cbg-auth-form" @submit.prevent="saveChanges">
      <div class="cbg-account__info">
        <div class="cbg-account__personal">
          <div class="cbg-account__personal-data">
            <Input ref="nameInput" v-model="tempUserData.nickname" class-name="cbg-account__personal-data-input" input-name="CBG name" :is-locked="true" :is-editable="true" :is-required="true" :is-wrong="isNickWrong"/>
            <Input v-model="tempUserData.email" class-name="cbg-account__personal-data-input" input-name="Email" :is-locked="true" validation-type="email"/>
            <div v-if="!isProviderAuth" class="cbg-account__personal-data__password">
              <Input v-model="passwordStub" class-name="cbg-account__personal-data-input" input-name="Password" :is-locked="true" :is-editable="true" :is-secured="true" data-type="password"/>
              <p class="cbg-account__personal-data__password-change">Changed {{lastPasswordUpdate}}</p>
            </div>
          </div>
          <div class="cbg-account__personal-photo">
            <div class="cbg-account__personal-photo__img">
              <span v-if="!tempUserData.avatar" class="cbg-account__personal-photo__img-default" >{{nameLetter}}</span>
              <img v-else class="cbg-account__personal-photo__img-content" :src="tempUserData.avatar" alt="Account photo">
            </div>
            <div class="cbg-account__personal-photo__upload">
              <input class="cbg-account__personal-photo__upload-input" type="file" id="file" accept="image/*" @change="handlePhotoChange"/>
              <label class="cbg-account__personal-photo__upload-label" for="file">Upload photo</label>
            </div>
            <button class="cbg-account__personal-photo__delete" :disabled="!tempUserData.avatar" type="button" @click="resetPhoto">Delete</button>
          </div>
        </div>
        <Input ref="firstNameInput" v-model="tempUserData.firstname" class-name="cbg-account__input" input-name="First name" :is-locked="true" :is-editable="true"/>
        <Input ref="lastNameInput" v-model="tempUserData.lastname" class-name="cbg-account__input" input-name="Last name" :is-locked="true" :is-editable="true"/>
        <Dropdown v-model="tempUserData.gender" dropdown-name="Gender" default-value="none" :options="genders"/>
        <Dropdown v-model="tempUserData.location"  dropdown-name="Location" :options="countries" :with-search="true"/>
        <Input ref="phoneInput" v-model="tempUserData.phone" class-name="cbg-account__input" input-name="Phone number" :is-locked="true" :is-editable="true" validation-type="phone" data-type="tel"/>
      </div>
      <button class="cbg-account__button" :disabled="isDisabled || isLoading" type="submit">
        <span class="cbg-account__button-text">Done</span>
        <Svg v-if="!isLoading" class-name="cbg-account__button-ico" icon-id="#ok"/>
        <span v-else class="spinner"></span>
      </button>
      <!--    <p class="cbg-account__text">-->
      <!--      Fill in <a href="#">Forum Settings</a> to complete your profile-->
      <!--    </p>-->
    </form>
  </div>
</template>

<script>
import Input from "@/components/elements/Input.vue";
import Svg from "@/components/global/Svg.vue";
import Dropdown from "@/components/elements/Dropdown.vue";
import {GENDERS, PASSWORD_STUB} from "@/utils/constants";
import {formValidation} from "@/mixins/formValidation";
import {sendRequests} from "@/mixins/sendRequests";
import {userData} from "@/mixins/userData";
import {requestValidation} from "@/mixins/requestValidation";
export default {
  name: 'AccountSettings',
  components: {
    Dropdown,
    Svg,
    Input
  },
  mixins: [requestValidation, formValidation, sendRequests, userData],
  data() {
    return {
      passwordStub: '***********',
      genders: GENDERS,
      countries: [],
      oldUserData: null,
      tempUserData: null,
      isSettings: true,
    }
  },
  computed: {
    isProviderAuth() {
      return this.context?.isProviderAuth;
    },
  },
  methods: {
    async loadCountries() {
      try {
        let path = '';
        if (typeof vuePath !== 'undefined') {
          path = vuePath['url'];
        }
        const response = await fetch(`${path}/countries.json`);
        const jsonData = await response.json();

        if (jsonData && jsonData.data) {
          this.countries = jsonData.data;
        }
      } catch (error) {
        console.error('Ошибка при загрузке данных из файла:', error);
      }
    },
    saveChanges() {
      this.isValidAll(true);
      this.returnToValidSettings();

      if(!this.isDisabled) {
        this.changeUserRequest(this.tempUserData);
      }
    }
  },
  mounted() {
    this.loadCountries();
    this.oldUserData = { ...this.userData };
    this.tempUserData = { ...this.userData };
  },
}
</script>